import pt from 'prop-types';

export const SheetPropType = pt.shape({
  background: pt.shape({
    imageUrl: pt.string,
  }),
  backgroundId: pt.string,
  imageType: pt.shape({
    classname: pt.string,
    count: pt.number,
    name: pt.string,
  }).isRequired,
  imageTypeId: pt.oneOfType([pt.number, pt.string]).isRequired,
  pose: pt.shape({
    watermarkUrl: pt.string,
    imageUrl: pt.string,
  }).isRequired,
  poseId: pt.string.isRequired,
});
